<template>
  <Grid
    gtc="1fr 1fr"
    gta="'total-info department-info' 'table table'"
    gap="var(--r-space-md) var(--r-space-sp)"
    class="full-height"
  >
    <DepartmentInfo class="sticky-card" />
    <TotalInfo class="sticky-card" />
    <RenewalProposalTable :key="rerenderTable" @rerender-table="rerenderTable++" />
  </Grid>
</template>

<script>
import RenewalProposalModule from './renewal-proposal-module'
// Libraries
import { mapActions } from 'vuex'
// Components
import RenewalProposalTable from './components/renewal-proposal-table/RenewalProposalTable'
import DepartmentInfo from './components/DepartmentInfo'
import TotalInfo from './components/TotalInfo'

export default {
  components: {
    RenewalProposalTable,
    DepartmentInfo,
    TotalInfo
  },

  data: () => ({
    rerenderTable: 1
  }),

  beforeCreate() {
    this.$store.registerModule('renewal-proposal', RenewalProposalModule)
  },

  created() {
    this.getAndSetStatuses()
    this.getAndSetRecommendationStatuses()
  },

  beforeDestroy() {
    this.$store.unregisterModule('renewal-proposal')
  },

  methods: {
    ...mapActions('renewal-proposal', ['getAndSetStatuses', 'getAndSetRecommendationStatuses'])
  }
}
</script>

<style lang="scss" scoped>
.sticky-card {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
